import {
  Dimensions3D,
  KnownHubDtoType,
  KnownModuleDtoStatus,
  ModuleDto,
  PositionWithAngle2D
} from '@groundfloor-platform/mgmt-service-g-sdk';

export class Module {
  public readonly sequenceNumber: number;
  public readonly id: string;
  public readonly name: string;
  public readonly createdTime: Date;
  public readonly status: KnownModuleDtoStatus;
  public readonly inventoryID?: string;
  public readonly isReferenceModule: boolean;
  public readonly bottomLeftPosition: PositionWithAngle2D;
  public readonly dimensions: Dimensions3D;
  public readonly hubType: KnownHubDtoType;

  constructor(module: ModuleDto, hubType: KnownHubDtoType) {
    this.sequenceNumber = module.sequenceNumber;
    this.id = module.id;
    this.name = module.name;
    this.createdTime = module.createdTime;
    this.status = module.status as KnownModuleDtoStatus;
    this.inventoryID = module.inventoryID;
    this.isReferenceModule = module.isReferenceModule;
    this.bottomLeftPosition = module.bottomLeftPosition;
    this.dimensions = module.dimensions;
    this.hubType = hubType;
  }

  public get title(): string {
    return this.name;
  }
}
